import React from 'react';
import { Provider } from 'react-redux';
import 'react-id-swiper/src/styles/scss/swiper.scss';
import './static/css/main.scss';
import Routers from './routes/index';
import configureStore from './store/configureStore';
const store = configureStore();

// store.subscribe(() =>
//     console.log(store.getState())
// );

const Root = () => (
	<Provider store={store}>
		<Routers />
	</Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/root.js